<div class="audit-date-row">
	<div class="row-wrapper">
		<div class="audit-date-label-flex">
			<label class="date-label">{{'additional-questions.audit-dates.transfer-audit-date' | translate}}
				<span class="optional-label">{{'common.optional' | translate}}</span>
			</label>
		</div>
	</div>
	<div class="row-wrapper">
		<div>
			<date-picker [id]="'desired-next-audit-date'" [controlName]="'desiredNextAuditDate' + product.standard.name" [formGroup]="form" [value]="product.additionalQuestions.desiredNextAuditDate"
						 (onDateChangeInDefault)="updateDateFormControlAndValidateAllDates('desiredNextAuditDate', $event)"
						 [invalidDate]="isInvalid('desiredNextAuditDate')">
			</date-picker>
			<div class="validation-message">{{getErrorsIfInvalid('desiredNextAuditDate') | async}}</div>
		</div>
	</div>
</div>
